import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import breakpoints from '../../../config/breakpoints';
import { imagePropTypes } from '../../../propTypes';

import Picture from '../Picture';
import VideoPlayer from '../VideoPlayer';

const propTypes = exact({
  title: PropTypes.string,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  image: imagePropTypes,
  videoUrl: PropTypes.string,
  fallbackImage: imagePropTypes,
});

const defaultProps = {
  title: null,
  subTitle: '',
  description: '',
  image: undefined,
  videoUrl: '',
  fallbackImage: undefined,
};

class HeroBanner extends Component {
  constructor(props) {
    super(props);

    this.checkIfMobile = this.checkIfMobile.bind(this);

    this.handleWindowResize = null;

    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this.handleWindowResize = debounce(this.checkIfMobile, 200);
    window.addEventListener('resize', this.handleWindowResize, { passive: true });
    this.checkIfMobile();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  checkIfMobile() {
    if (window.innerWidth < breakpoints.tablet) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  }

  render() {
    const { image, title, subTitle, description, videoUrl, fallbackImage } = this.props;
    const { isMobile } = this.state;

    const imageToUse = image || fallbackImage;
    const useVideo = videoUrl && !isMobile;

    return (
      <div className="HeroBanner">
        <div className="HeroBanner_bgContainer">
          {useVideo && (
            <div className="HeroBanner_bgVideo">
              <VideoPlayer videoUrl={videoUrl} fallbackImage={fallbackImage} autoplay noControls />
            </div>
          )}
          {imageToUse && (
            <Picture
              {...imageToUse}
              className="HeroBanner_bgImage"
              sizes={[
                [100, '416'], // from 0
                [100, '416'], // from 480
                [100, '416'], // from 768
                [100, '416'], // from 1024
                [90, '416'], // from 1440
              ]}
            />
          )}
        </div>
        {title && (
          <div className="HeroBanner_content">
            <h1 className="HeroBanner_title">{title}</h1>
            {subTitle && <h2 className="HeroBanner_subTitle">{subTitle}</h2>}
            {description && <p className="HeroBanner_description">{description}</p>}
          </div>
        )}
      </div>
    );
  }
}

HeroBanner.propTypes = propTypes;
HeroBanner.defaultProps = defaultProps;

export default HeroBanner;
